import { render, staticRenderFns } from "./OutwardList.vue?vue&type=template&id=37574911&scoped=true&"
import script from "./OutwardList.vue?vue&type=script&lang=js&"
export * from "./OutwardList.vue?vue&type=script&lang=js&"
import style0 from "./OutwardList.vue?vue&type=style&index=0&id=37574911&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37574911",
  null
  
)

export default component.exports